import { Contract, ethers } from "ethers";
import {
  BaseProvider,
  JsonRpcProvider,
  Web3Provider,
} from "@ethersproject/providers";
import { AbiService } from "../abi";
import { AppError, AppStatus, EthereumService } from "../../types";
import { RetryService } from "../RetryService";

const isMetaMaskConnected = async (
  provider: ethers.providers.JsonRpcProvider
) => {
  const accounts = await (provider as Web3Provider).listAccounts();
  return accounts.length > 0;
};

export class BasicEthereumService implements EthereumService {
  error?: AppError | undefined;

  mintedCount = 0;

  provider?: ethers.providers.BaseProvider | undefined;

  abi?: AbiService | undefined;

  writableAbi?: AbiService | undefined;

  wallet?: string | undefined;

  async buy(amount: number): Promise<any> {
    const amountToBn = this.amountToBn(amount);
    try {
      const mint = await this.writableAbi?.mint(amount, amountToBn);
      return mint;
    } catch (e: any) {
      console.info("BasicEthereumService:buy", e);
      if (e?.code === 4001) {
        throw new Error(AppError.UserDeniedTransaction);
      }
    }
  }

  async mintRef(amount: number, ref: string): Promise<any> {
    const amountToBn = this.amountToBn(amount);
    console.info("MINTREF", amount, ref, amountToBn);
    try {
      // @ts-ignore
      const mint = await this.writableAbi?.mintRef(amount, amountToBn, ref);
      return mint;
    } catch (e: any) {
      console.info("BasicEthereumService:buy", e);
      if (e?.code === 4001) {
        throw new Error(AppError.UserDeniedTransaction);
      }
    }
  }

  async mintFreeOne(): Promise<any> {
    console.info("mintFreeOne", this.writableAbi);
    const mint = await this.writableAbi?.mintFreeOne();
    return mint;
  }

  amountToBn(n: number) {
    return n as any;
  }

  static checkIfMetaMaskConnected(provider: JsonRpcProvider) {
    return isMetaMaskConnected(provider);
  }

  async getMintedCount() {
    return -1;
  }

  async connect(): Promise<AppStatus | undefined> {
    return undefined;
  }

  public getProvider() {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      return provider;
    } catch (e) {
      console.info("getProvider", e);
      throw new Error(AppError.NoEthereum);
    }
  }

  getContract(provider: BaseProvider): Contract | null {
    return null;
  }

  public async checkIfConnected(provider: JsonRpcProvider): Promise<boolean> {
    return BasicEthereumService.checkIfMetaMaskConnected(provider);
  }

  public async checkIfStarted(): Promise<boolean> {
    return new RetryService(this.abi?.isStarted.bind(this.abi))
      .setOnError((e: any) => {
        this.error = AppError.WrongNetwork;
      })
      .run();
  }

  public async initMintedCount(): Promise<number> {
    return new RetryService(this.abi?.getMintedCount.bind(this.abi))
      .setOnError((e: any) => {
        this.error = AppError.WrongNetwork;
      })
      .run();
  }

  public async initCurrentTokenPrice(): Promise<string> {
    return new RetryService(this.abi?.getTokenPrice.bind(this.abi))
      .setOnError((e: any) => {
        this.error = AppError.WrongNetwork;
      })
      .run();
  }

  async init(): Promise<AppStatus> {
    return AppStatus.Disconnected;
  }
}
